import { render, staticRenderFns } from "./NewProgramForm.vue?vue&type=template&id=21c3c8dd"
import script from "./NewProgramForm.vue?vue&type=script&lang=js"
export * from "./NewProgramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports